import { VersionActionType } from '../actionTypes/version';
import { VersionType, PostDispatch } from '../types';

const VERSION_INIT: VersionType = {
    version: '',
};

const versionReducer = (
    state = VERSION_INIT,
    action: PostDispatch
): VersionType => {
    switch (action.type) {
        case VersionActionType.GET_LATEST_VERSION:
            return action.payload as VersionType;
        default:
            return state as VersionType;
    }
};
export default versionReducer;
